import Blue from "~/core";

new Blue({
	name: 'Alert',
	selector: ".alert",
	setup(alert) {
		const main = document.querySelector("main.content");
		const header = document.querySelector('.header');
		const alertClose = alert.querySelector('.alert__close');
		const drawer = header ? header.querySelector('.header__drawer') : false;
		let name = alert.dataset.name;
		let version = alert.dataset.version;
		let expire = parseInt(alert.dataset.expire);
		let dismissed = `${name}_Alert--dismissed-${version}`;

		if(this.$getCookie(dismissed)) {
			alert.remove();
			setTimeout(() => {
				if(alert) {
					drawer.style.top = `${header.offsetHeight}px`;
				} else {
					drawer.style.top = `${header.offsetHeight}px`;
				}
			},200);
		}

		this.$addEvents(alertClose, 'click.prevent', () => {
			this.$setCookie(dismissed, true, expire);
			alert.remove();
			const alertClosedEvent = new CustomEvent("alertClosed");
			document.dispatchEvent(alertClosedEvent);
			setTimeout(() => {
				if(alert) {
					drawer.style.top = `${header.offsetHeight}px`;
				} else {
					drawer.style.top = `${header.offsetHeight}px`;
				}
			},200);
		})
	}
});